/* Scroll-reveal delle sezioni landing — CSS in lz-base.css (.lz-reveal).
   Progressive enhancement: senza questo script (o con reduced-motion) la
   classe lz-reveal-armed non viene mai aggiunta e tutto resta visibile. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var sections = Array.prototype.slice
    .call(document.querySelectorAll('#root > .shopify-section'))
    .filter(function (el, i) {
      // Escluse: header (primo, sticky) e cart-bar (position:fixed — un
      // transform sull'antenato ne romperebbe l'ancoraggio al viewport).
      return i > 0 && !el.querySelector('.lz-cart-bar');
    });
  if (!sections.length) return;

  var vh = window.innerHeight;
  sections.forEach(function (el) {
    el.classList.add('lz-reveal');
    if (el.getBoundingClientRect().top < vh) el.classList.add('is-in');
  });
  document.documentElement.classList.add('lz-reveal-armed');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px' });

  sections.forEach(function (el) {
    if (!el.classList.contains('is-in')) io.observe(el);
  });
})();
